import Modal from "@/components/common/generalModal";
import { FC } from "react";
import { Button, ButtonType } from "@/components/common/button";

interface IYourTreatmentOptionsModalProps {
  open: boolean;
  weightDifference: number;
  onClose: () => void;
  version?: 'v1' | 'v2';
}

export const YourTreatmentOptionsModal: FC<IYourTreatmentOptionsModalProps> = ({
  open,
  weightDifference,
  onClose,
  version = 'v2'
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={open} backgroundStyle="none" onClose={() => {}}>
      <div className="max-w-[500px] w-full mx-auto">
        <h2 className="section-title">
          {weightDifference
            ? `We can help you lose ${weightDifference} lbs!`
            : "Your weight loss solutions"}
        </h2>

        <p className="texst-sm text-second-text-v2">
          Our medications get delivered within just a few days if you’re
          approved!
        </p>
        <div className="flex flex-col items-start justify-center gap-2 mb-4">
          <Button
            onClick={handleClose}
            version="v2"
            btnClassName={version === 'v1' ? 'bg-purple-3' : ''}
            type={ButtonType.CONTINUE}
          />
        </div>
      </div>
    </Modal>
  );
};
